let isSquare = document.querySelector('.default-square')

function getSwiperDirection() {
  if (window.innerWidth >= 1024) {
    return isSquare ? 'vertical' : 'horizontal'
  }
  return 'horizontal'
}

const productImagesSwiper = new Swiper('.swiper-media-list', {
  direction: getSwiperDirection(),
  slidesPerView: 5,
  spaceBetween: 10,
  speed: 600,
  freeMode: false,
  watchSlidesProgress: true,
  slideToClickedSlide: true,
  watchSlidesVisibility: true,
  watchOverflow: false,
  mousewheel: {
    forceToAxis: true,
    releaseOnEdges: true,
    sensitivity: 1,
  },
  simulateTouch: true,
  touchRatio: 1,
  grabCursor: true,
  breakpoints: {
    1201: { slidesPerView: 4 },
    900: { slidesPerView: 3 },
    320: { slidesPerView: 4 },
  },
})

const productMainImagesSwiper = new Swiper('.main-product-swiper', {
  slidesPerView: 1,
  speed: 600,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    disabledClass: 'swiper-button-disabled',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
    dynamicBullets: false,
    dynamicMainBullets: 6,
  },
  thumbs: {
    swiper: productImagesSwiper,
  },
})

// ✅ Image and Variant handling
const productImagesSwiperSliders = productImagesSwiper.slides
const productVariants = document.querySelectorAll('.c-option-item'),
  productCurrentTexts = document.querySelectorAll('.current-value-variant'),
  productVariantWrapper = document.querySelectorAll('.js.product-form__input'),
  cartTriggerSectionButton = document.querySelector('.cartAddJsTrigger'),
  scrollWidgetButton = document.querySelector(
    '.scrollingWidget__actions .product-form-button-c'
  ),
  productFormTexts = document.querySelectorAll('.form-text-js')

productVariants.forEach((option) => {
  option.addEventListener('click', () => {
    productCurrentTexts.forEach((text) => {
      if (text.dataset.name == option.dataset.name) {
        text.innerText = option.dataset.value
      }
    })

    setTimeout(function () {
      document.querySelectorAll('.prod-variants span').forEach((item) => {
        if (
          item.dataset.variantId == window.location.href.split('?variant=')[1]
        ) {
          productImagesSwiperSliders.forEach((slide) => {
            if (slide.dataset.imgId == item.dataset.img) slide.click()
          })
        }
      })

      const locationString = window.location.search
      if (locationString.includes('?variant=')) {
        const variantId = locationString.replace('?variant=', '')
        productFormTexts.forEach((text) => {
          text.dataset.id == variantId
            ? text.classList.add('is-active')
            : text.classList.remove('is-active')
        })
      }
    }, 0)
  })
})

if (localStorage.getItem('selected-variant') == 'false') {
  productVariantWrapper.forEach((variant) => {
    const firstVariant = variant.querySelector('.c-option-item')
    if (firstVariant) firstVariant.click()
  })
}

$(document).on('cart.requestComplete', function (event, cart) {
  console.log('was added')
})

if (cartTriggerSectionButton) {
  cartTriggerSectionButton.addEventListener('click', () => {
    setTimeout(() => {
      scrollWidgetButton.click()
    }, 300)
  })
}

// ✅ Variant text highlighting
productFormTexts.forEach((text, index) => {
  const locationString = window.location.search
  if (locationString.includes('?variant=')) {
    const variantId = locationString.replace('?variant=', '')
    text.dataset.id == variantId
      ? text.classList.add('is-active')
      : text.classList.remove('is-active')
  } else {
    index === 0
      ? text.classList.add('is-active')
      : text.classList.remove('is-active')
  }
})

// ✅ Sticky Add-to-Cart Bar
window.addEventListener('scroll', function () {
  var distanceFromTop = $(document).scrollTop()
  if (distanceFromTop >= 200) {
    jQuery('div.atcbar.custom').fadeIn(400).removeClass('hidden')
    jQuery('body').addClass('enable-add-to-sticky')
  } else {
    jQuery('div.atcbar.custom').fadeOut(400).addClass('hidden')
    jQuery('body').removeClass('enable-add-to-sticky')
  }

  if (jQuery('.scrollingWidget--active').length) {
    jQuery('body').addClass('enable-add-to-sticky')
  } else {
    jQuery('body').removeClass('enable-add-to-sticky')
  }
})

window.addEventListener('resize', function () {
  var newDirection = getSwiperDirection()
  if (productImagesSwiper.params.direction !== newDirection) {
    productImagesSwiper.changeDirection(newDirection)
  }
})
